<p class="section-description">
  Tab-status-bar variants grouped by tab and sync phase. Mirrors the markup that renders inside ApplicationComponent so
  styling stays in sync via the global <code>.tab-status-bar</code> styles in <code>styles.scss</code>.
</p>
@for (group of tabStatusGroups; track group) {
  <div class="tab-status-tab-group">
    <div class="tab-status-tab-group__header clickable" (click)="toggleGroup(group.key)">
      <h3 class="tab-status-tab-group__title">{{ group.tab }}</h3>
      <i
        class="fa-solid tab-status-tab-group__chevron"
        [class.fa-chevron-down]="!expandedGroups[group.key]"
        [class.fa-chevron-up]="expandedGroups[group.key]"
      ></i>
    </div>
    @if (expandedGroups[group.key]) {
      <div class="tab-status-tab-group__body">
        @for (phaseGroup of group.phases; track phaseGroup) {
          <div class="tab-status-phase-group">
            <h4 class="tab-status-phase-group__title">{{ phaseGroup.phase }}</h4>
            <div class="tab-status-variant-list">
              @for (variant of phaseGroup.variants; track variant) {
                <div class="tab-status-variant">
                  <div class="tab-status-variant__label">{{ variant.label }}</div>
                  <showcase-status-bar [status]="variant.status"></showcase-status-bar>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
